import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/login'
import Customer from '../pages/customer/index'
import CustomerSearch from '../pages/customer/search'
import CustomerCheck from '../pages/customer/check'
import CustomerCreate from '../pages/customer/create'
import CustomerEdit from '../pages/customer/edit'
import Employee from '../pages/employee/index'
import Remind from '../pages/remind/index'
import Task from '../pages/task/index'
import TaskEdit from '../pages/task/edit'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/customer/search',
      name: 'customer-search',
      component: CustomerSearch,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/customer/check',
      name: 'customer-check',
      component: CustomerCheck
    },
    {
      path: '/customer/create/:mobile',
      name: 'customer-create',
      component: CustomerCreate
    },
    {
      path: '/customer/edit/:id/:from',
      name: 'customer-edit',
      component: CustomerEdit
    },
    {
      path: '/employee',
      name: 'employee',
      component: Employee
    },
    {
      path: '/remind',
      name: 'remind',
      component: Remind,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/task',
      name: 'task',
      component: Task,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/task/edit/:id',
      name: 'task-edit',
      component: TaskEdit,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js